import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NetworkServiceModel      from '@/models/NetworkServiceModel';
import OwnerUserModel           from './OwnerUserModel';

@model.urnResource('contact')
@doc.path('/contacts/{?id}')
export default class ContactModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
		"ownerUser": id;
		"ownerUser.userUrn": Urn;
		"relationContacts.relation.relationStatus": id;
		"relationContacts.relation.relationStatus.reference": string;
	};

	private declare _tsSorts: {
		'firstname': string;
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(OwnerUserModel) declare ownerUser: OwnerUserModel;
	@doc.number declare gender: number;
	@doc.string declare firstname: string;
	@doc.string declare lastname: string;
	@doc.string declare email: string;
	@doc.string declare photoUrl: string | null;
	@doc.string declare userUrn: string | null;

	get fullName() {
		return this.get('firstname', '') + ' ' + this.get('lastname', '');
	}
}